import './ConfirmModal.css';

const ConfirmModal = ({ 
    message, 
    onConfirmAction, 
    onCancelAction, 
    confirmText = "확인", 
    cancelText = "취소" 
}) => {
    return (
        
        <div className="confirmation-modal-container"> {/* Renamed class for clarity */}
            <div className="confirmation-modal-message">
                {message}
            </div>
            <div className="confirm-footer">
                <div className="button-group">
                    <button onClick={onConfirmAction} className="confirmation-modal-button confirm">{confirmText}</button>
                    <button onClick={onCancelAction}  className="confirmation-modal-button cancel">{cancelText}</button>
                </div>
            </div>
        </div>
    );
};

export default ConfirmModal;
